import type { ChannelRecord } from '@nadoutong/contracts';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../hooks/useSession.tsx';
import { listChannels } from './channels.ts';

const CHANNELS_KEY = ['channels'] as const;

export function useChannelsList(): UseQueryResult<readonly ChannelRecord[]> {
  const { fetchImpl } = useSession();
  return useQuery({
    queryKey: CHANNELS_KEY,
    queryFn: async ({ signal }) => {
      const res = await listChannels(fetchImpl, signal);
      return res.channels;
    },
  });
}
